import React from 'react';
import { LocalPopup } from 'js/components/common/Popup';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import * as hooks from './hooks';
import * as hocs from '../../hocs';
import { PagePopup } from '../PagePopup';

import style from './PageInPopup.scss';

export const PageInPopupBare = ({ page, error, isLoading, fetchPageInfo }) => {
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();

    hooks.useLegacyPageAsPopupCloseSubscription();
    hooks.useCMSIntegration({ page, fetchPageInfo });

    if (!page) {
        return null;
    }

    if (error) {
        return (
            <LocalPopup
                onClose={navigateToPopupBackgroundPage}
                style={{ width: '30em' }}
                className={style.container}
            >
                <ErrorMessage
                    className={style.error}
                    message={'playtech.mobile.system.error.no.response'}
                />
            </LocalPopup>
        );
    }

    return (
        <PagePopup isLoading={isLoading} page={page} />
    );
};

export const PageInPopup = hocs.withCommonPage(PageInPopupBare, true);
